class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    
  }
  bindEvents() {
    if(document.querySelector("#minicart-drawer-toggle")){
       document.querySelector("#minicart-drawer-toggle").addEventListener('click', this.openDrawer.bind(this))
    }
    this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
      button.addEventListener('click', this.closeDrawer.bind(this))
    );
  }
  openDrawer(event) {
    event.preventDefault();
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
       document.getElementById('minicart').innerHTML = this.getSectionInnerHTML(html, 'minicart');
         if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }
       document.querySelector("#minicart").classList.add("active");
       document.querySelector("body").classList.add("no-scroll");
        this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
        button.addEventListener('click', this.closeDrawer.bind(this))
    );
      setTimeout(function(){
        trapFocusElements(document.querySelector("#minicart"))
      },500)
        setTimeout(function(){
       fetch("/cart.js")
      .then(response => response.json())
       .then((data) => {
            let totalprice=data.total_price;
          shippingProgressBar(totalprice)
        
       })
    },500)
     
      })
      .catch(e => {
        console.error(e);
      });
  }
  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
       let parseElement= this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        document.querySelector(section.selector).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if(document.querySelector("#cart-upsell-product")){
          themeSlidersInit($("#cart-upsell-product"));
        }
        let totalCount = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html').querySelector("mini-cart").getAttribute("data-cart-count");
         if(document.querySelector("[data-header-cart-count]")){
             if( document.querySelector("[data-header-cart-count]").classList.contains("hidden")){
                document.querySelector("[data-header-cart-count]").classList.remove("hidden")
             }
             if(totalCount == 0){
                document.querySelector("[data-header-cart-count]").classList.add("hidden")
             }
             else if(totalCount < 100){
               document.querySelector("[data-header-cart-count]").textContent = totalCount;
             }else {
               document.querySelector("[data-header-cart-count]").textContent = '';
             }
         }
       this.querySelectorAll('[data-sideDrawer-close]').forEach((button) =>
          button.addEventListener('click', this.closeDrawer.bind(this))
        );
     
      }
    }));
    setTimeout(function(){
       fetch("/cart.js")
      .then(response => response.json())
       .then((data) => {
            let totalprice=data.total_price;
          shippingProgressBar(totalprice)
        
       })
    },500)
     
    
    
  }
  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];
  }
  getSectionInnerHTML(html, selector = 'cart-drawer') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector("cart-drawer").innerHTML;
  }
  closeDrawer(event){
     event.preventDefault();
     const closeElement = event.currentTarget;
      if(closeElement.closest(".side-drawer-panel").classList.contains("active")){
        closeElement.closest(".side-drawer-panel").classList.remove("active");
         document.querySelector("body").classList.remove("no-scroll");
      }
      
  }
}

customElements.define('cart-drawer', MiniCart);


;(() => {
  const SELECTOR_BTN = 'button[type="submit"][name="add"]';

  function findProductForm(btn) {
    const wrap = btn.closest('.amz-atc-price-wrapper') || btn.closest('[data-section-id]');
    if (wrap) {
      const sectionId = wrap.getAttribute('data-section-id');
      if (sectionId) {
        const byId = document.getElementById(`product-form-${sectionId}`);
        if (byId) return byId;
      }
      const formInWrap = wrap.querySelector('form[data-type="add-to-cart-form"], form[action^="/cart/add"]');
      if (formInWrap) return formInWrap;
    }
    const pf = btn.closest('product-form');
    if (pf) {
      const f = pf.querySelector('form[data-type="add-to-cart-form"], form[action^="/cart/add"]');
      if (f) return f;
    }
    const any = document.querySelector('form[data-type="add-to-cart-form"], form[action^="/cart/add"]');
    return any || null;
  }

  function openMiniCart() {
    const drawer = document.querySelector('cart-drawer#minicart, cart-drawer.minicart-panel');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer({ preventDefault() {} });
      return true;
    }
    const toggle = document.querySelector('#minicart-drawer-toggle, [data-minicart-toggle], a[href*="mini-cart"]');
    if (toggle) {
      toggle.click();
      return true;
    }
    return false;
  }

  async function ajaxAddToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    });
    if (!res.ok) {
      let errText = '';
      try { errText = await res.text(); } catch(e) {}
      throw new Error(errText || `Add to cart failed (${res.status})`);
    }
    return res.json();
  }

  function setLoading(btn, loading) {
    btn.classList.toggle('is-loading', !!loading);
    const spinner = btn.querySelector('.btn-loader');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(SELECTOR_BTN);
    if (!btn) return;

    // Only handle product-page ATC (avoid cart page / other forms)
    const wrap = btn.closest('.amz-atc-price-wrapper');
    if (!wrap) return;

    const form = findProductForm(btn);
    if (!form) return;

    // Fix the broken form attribute if present
    const formAttr = btn.getAttribute('form');
    if (formAttr && /^\[object\s/i.test(formAttr)) {
      btn.setAttribute('form', form.id);
    } else if (!btn.closest('form') && (!formAttr || formAttr !== form.id)) {
      btn.setAttribute('form', form.id);
    }

    // Prevent normal navigation submit (redirect to cart)
    e.preventDefault();
    e.stopPropagation();

    try {
      setLoading(btn, true);
      await ajaxAddToCart(form);
      // refresh and open drawer
      openMiniCart();
    } catch (err) {
      // If ajax fails, fall back to normal submit (still better than dead click)
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(btn);
        else form.submit();
      } catch (e2) {}
    } finally {
      setLoading(btn, false);
    }
  }, true);
})();

